import { ChangeDetectionStrategy, Component, input, output } from '@angular/core';

import { AssetEpisodeCardComponent } from '@features/assets/components/asset-episode-card/asset-episode-card.component';
import { IExtrasItemDto } from '@features/assets/data-access/api-shared.dto';

/** Shared "Dodatni sadržaj" tab — extras rendered as play-on-click cards. */
@Component({
    selector: 'details-extras',
    standalone: true,
    imports: [AssetEpisodeCardComponent],
    templateUrl: './details-extras.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DetailsExtras {
    readonly extras = input.required<readonly IExtrasItemDto[]>();

    readonly playExtra = output<IExtrasItemDto>();
}
